<div style="text-align: center">
  <div class="modal-header">
    <h3></h3>
    <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" class="modal-close-btn" (click)="close(false)">
  </div>
  <div class="modal-body">
    <div style="padding-bottom: 4rem">
      <h3 style="padding: 5rem 2rem">{{'role_request_modal_title' | translate}}</h3>
      <div style="display: inline-flex; align-items: center;">
        <img *ngIf="data.workspaceCreatorImage !== ''"
             class="user-image" style="width: 4rem; height: 4rem"
             src="{{apiwrapper.baseUrl + data.workspaceCreatorImage}}">

        <h5 [innerHTML]="('role_request_modal_description' | translate: {name: data.workspaceOwnerName})"></h5>
      </div>
    </div>
  </div>
  <div class="modal-footer request-footer">
    <button class="btn-hallow" aria-label="Close" (click)="close(false)">{{'role_request_modal_cancel_btn' | translate}}</button>
    <button class="btn-blue request-button" (click)="requestRole()">{{'role_request_modal_request_btn' | translate}}</button>
  </div>
</div>
